import type { CourseTemplate } from '@/api/types'

/**
 * 课程模板 Mock 数据 (TEACH-01)
 * Q3决策: 课程类型(GROUP/PRIVATE/TRIAL)与会员卡类型对应
 * Q决策: 去除分类(category)，增加消耗次数(consumptionCount)
 */

export const mockCourses: CourseTemplate[] = [
  {
    id: 'tpl-001',
    brandId: 'b-001',
    name: '少儿篮球基础班',
    type: 'GROUP',
    durationMin: 60,
    defaultCapacity: 12,
    consumptionCount: 1,
    description: '针对6-12岁少儿的篮球基础训练课程，涵盖运球、传球、投篮等基本技能',
    status: 'PUBLISHED',
    createdAt: '2025-08-01T08:00:00Z',
    updatedAt: '2025-09-15T10:00:00Z',
    createdBy: 'u-boss-001',
    updatedBy: 'u-principal-001',
  },
  {
    id: 'tpl-002',
    brandId: 'b-001',
    name: '私教体能训练',
    type: 'PRIVATE',
    durationMin: 45,
    defaultCapacity: 1,
    consumptionCount: 1,
    description: '一对一专属体能训练，根据学员体质定制训练方案',
    status: 'PUBLISHED',
    createdAt: '2025-08-05T08:00:00Z',
    updatedAt: '2025-09-20T14:00:00Z',
    createdBy: 'u-principal-001',
    updatedBy: 'u-principal-001',
  },
  {
    id: 'tpl-003',
    brandId: 'b-001',
    name: '少儿足球启蒙',
    type: 'GROUP',
    durationMin: 60,
    defaultCapacity: 15,
    consumptionCount: 1,
    description: '面向5-8岁儿童的足球启蒙课程，培养运动兴趣和团队意识',
    status: 'PUBLISHED',
    createdAt: '2025-08-10T08:00:00Z',
    updatedAt: '2025-09-01T09:00:00Z',
    createdBy: 'u-principal-001',
    updatedBy: 'u-teacher-002',
  },
  {
    id: 'tpl-004',
    brandId: 'b-001',
    name: '体验课-篮球',
    type: 'TRIAL',
    durationMin: 30,
    defaultCapacity: 8,
    consumptionCount: 0,
    description: '篮球课程免费体验，面向新学员开放',
    status: 'PUBLISHED',
    createdAt: '2025-08-15T08:00:00Z',
    updatedAt: '2025-08-15T08:00:00Z',
    createdBy: 'u-principal-001',
    updatedBy: 'u-principal-001',
  },
  {
    id: 'tpl-005',
    brandId: 'b-001',
    name: '少儿游泳入门',
    type: 'GROUP',
    durationMin: 45,
    defaultCapacity: 8,
    consumptionCount: 1,
    description: '游泳基础教学，从熟悉水环境到掌握蛙泳基本动作',
    status: 'PUBLISHED',
    createdAt: '2025-08-20T08:00:00Z',
    updatedAt: '2025-09-10T11:00:00Z',
    createdBy: 'u-principal-001',
    updatedBy: 'u-teacher-001',
  },
  {
    id: 'tpl-006',
    brandId: 'b-001',
    name: '少儿舞蹈基础',
    type: 'GROUP',
    durationMin: 60,
    defaultCapacity: 10,
    consumptionCount: 1,
    description: '少儿舞蹈基础课程，培养节奏感和身体协调性',
    status: 'DEPRECATED',
    createdAt: '2025-07-01T08:00:00Z',
    updatedAt: '2025-09-25T16:00:00Z',
    createdBy: 'u-boss-001',
    updatedBy: 'u-principal-001',
  },
  {
    id: 'tpl-007',
    brandId: 'b-001',
    name: '私教篮球进阶',
    type: 'PRIVATE',
    durationMin: 60,
    defaultCapacity: 1,
    consumptionCount: 1,
    description: '一对一篮球技巧进阶训练，适合有一定基础的学员',
    status: 'DRAFT',
    createdAt: '2025-09-28T08:00:00Z',
    updatedAt: '2025-09-28T08:00:00Z',
    createdBy: 'u-principal-001',
    updatedBy: 'u-principal-001',
  },
]
